import React from 'react'

const Partnerships = () => {
  return (
    <h1>Partnerships</h1>
  )
}

export default Partnerships